module.exports = __webpack_public_path__ + "img/shift4_logo.538925eb.svg";